import { z } from "zod";

export const AIMessageRole = {
	USER: "user",
	ASSISTANT: "assistant",
} as const;
export type AIMessageRole = (typeof AIMessageRole)[keyof typeof AIMessageRole];

export const aiChatMessageSchema = z.object({
	role: z.enum(AIMessageRole),
	content: z.string().min(1).max(4000),
});

export type AIChatMessage = z.infer<typeof aiChatMessageSchema>;

export const aiChatRequestSchema = z
	.object({
		messages: z.array(aiChatMessageSchema).min(1).max(20),
	})
	.strict();

export type AIChatRequest = z.infer<typeof aiChatRequestSchema>;
